import Vue from 'vue'

/**
 * Ensures invalid metric values is correctly formatted across platform.
 * Returns metric value or default placeholder when 'null' || 'undefined'
 * @member Filter
 * @name Metric Value Validator
 * @param {number} value
 * @returns {(String|number)}
 */
const metricValidator = (value) => {
  return !value && value !== 0 ? '-' : value
}

Vue.filter('metricValidator', metricValidator)

export default metricValidator
